export default {
  name: 'MenuDivider',
  props: {
    disabled: {
      type: Boolean,
      'default': true
    },
    rootPrefixCls: String
  },
  render: function render() {
    var h = arguments[0];
    var rootPrefixCls = this.$props.rootPrefixCls;

    return h('li', { 'class': rootPrefixCls + '-item-divider' });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-menu/Divider.js
// module id = 824
// module chunks = 0